import { useSettings } from "@Tmp/Hooks";
import useClickOutside from "@Tmp/Hooks/useClickOutside";
import InventoryStatus from "@Tmp/InventoryStatus";
import { LoadingLine } from "@Tmp/Loading";
import clsx from "clsx";
import * as React from "react";
import { IProductsLiveSearchMenuProps } from ".";

export const ProductsLiveSearchMenu: React.FC<IProductsLiveSearchMenuProps> = ({
    open,
    setOpen,
    value,
    onChange,
    onSelect,
    focused,
    loading,
    items,
    inputWrapperRef,
    setCurrentProduct,
    selectedItem,
    disablePrices,
    showInventory,
    ...props
}) => {
    const containerRef = React.useRef(null);
    useClickOutside([containerRef, inputWrapperRef], (e) => {
        setOpen(false);
    });

    const tmpSettings = useSettings();

    if (!value || !open) {
        return null;
    }

    return (
        <div className="tmp-live-search-container" ref={containerRef}>
            {loading && <LoadingLine />}
            <div className="tmp-live-search-content" style={{ minHeight: "150px" }}>
                {items.map((item) => (
                    <div
                        key={item.id}
                        className={clsx("tmp-live-search-item", {
                            "tmp-active": selectedItem?.product?.id === item.id,
                        })}
                        onClick={(e) => {
                            onChange(item.sku);
                            setOpen(false);
                            onSelect?.(item);
                            setCurrentProduct(item);
                        }}
                    >
                        <div className="tmp-live-search-item-image">
                            <img src={item.image} />
                        </div>
                        <div className="tmp-live-search-item-name">
                            <div>{item.name}</div>
                            <small className="tmp-live-search-item-number">{item.sku}</small>
                        </div>
                        <div className="tmp-live-search-item-price">
                            {!disablePrices && (
                                <>
                                    {item.price_info.price_format + " " + tmpSettings.currency}{" "}
                                    <br />
                                </>
                            )}
                            {showInventory && <InventoryStatus product={item} />}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};
